import styled from 'styled-components'
import { spacing } from '@global/theme'
import { row } from '@global/styles'

export const StyledPagination = styled.div`
  ${row}
  gap: ${spacing.threeQuarters};
`
